import { api } from "./api";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const needsHomeScreen = () => isIOS() && !isStandalone();

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const registration = async () => (await navigator.serviceWorker.getRegistration()) || navigator.serviceWorker.register("/sw.js");

export const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
};

// Asks permission (must run from a user tap) and registers this device with the backend.
export const enablePush = async (publicKey) => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return perm;
  const reg = await registration();
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(publicKey) });
  const json = sub.toJSON();
  await api.post("/notifications/subscriptions", { endpoint: json.endpoint, keys: json.keys, platform: navigator.userAgent.slice(0, 200) });
  return "granted";
};

export const disablePush = async () => {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.post("/notifications/subscriptions/remove", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
};
